export default __webpack_public_path__ + "static/bme-logo-4155c4c12d4e9f5f4eb0fc2ffdfd5eee.png";